import Upload from './Upload.vue'

export default Upload;



// WEBPACK FOOTER //
// ./src/components/Upload/index.js